/* ACTION CREATOR FUNCTIONS
Put here the functions that return an action object that can be dispatched
HINT: Always use functions for consistency, don't export plain objects
*/

import * as t from "./types";

// the actual redux action to initiate the load of users via a remote api. Note
// the special fields "meta" and "async" in the action -- these are required in
// order for the api middleware to recognize thsi action as a remote request
// and process it accordingly

const loadAllLocations = () => ({
    type: t.LOAD_ALL_LOCATIONS,
    meta: { path: `/location/`, async: true }
});

const loadLocations = locationPath => ({
    type: t.LOAD_LOCATIONS,
    meta: { path: `/location/${locationPath}`, async: true }
});

export { loadAllLocations, loadLocations };



// WEBPACK FOOTER //
// ./ducks/location-index/actions.js